module.exports = __webpack_public_path__ + "static/media/default-community.20cf567d.jpg";